import { render, staticRenderFns } from "./MyntChangePwsUAT.vue?vue&type=template&id=c28b08a2"
import script from "./MyntChangePwsUAT.vue?vue&type=script&lang=js"
export * from "./MyntChangePwsUAT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports